import styled from "styled-components";
import {JackpotBetWidgetGradientTextDefaultBox} from "./jackpot-bet-widget-gradient-text.default.box";

export const JackpotBetWidgetGradientTextMRGBox = styled(JackpotBetWidgetGradientTextDefaultBox)`

  letter-spacing: 0;
  line-height: 100%;

  text-transform: ${props => props.dontUpperCase ? "initial" : "uppercase"};
  
  background: linear-gradient(270deg, #F8F195 0.11%, #F8F3CA 50.11%, #F8F195 100.11%);

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
